import styles from 'views/ProductPage/configurators/variant/themes/BGH/styles.scss';
import showerStyle from '../../styles.scss';
import { ConfiguratorProps, ModalProps } from 'views/ProductPage/configurators/index';
import { ShowerDoorConfigurator } from 'models/ShowerDoorConfigurator';
import connect from 'components/Shared/connect';
import cn from 'classnames';
import { AttributeFilter } from 'views/ProductPage/configurators/variant/attributeFilter';
import { ReactElement } from 'react';
import { AttributeSelect } from 'views/ProductPage/configurators/variant/attributeSelect';
import { AttributeNumeric } from 'views/ProductPage/configurators/variant/attributeNumeric';
import { AttributeType } from 'models/AttributeType';
import { Attribute, useConfigurator } from 'views/ProductPage/configurators/useConfigurator';
import { AttributeImage } from 'views/ProductPage/configurators/variant/attributeImage';
import { match } from 'utils';
import { rules } from 'views/ProductPage/configurators/rules';
import { ToolTipDialog } from 'components/Shared/ToolTip/themes/BGH-RD3';
import { masterAttribute } from 'views/ProductPage/configurators/variant';

interface OwnProps extends ConfiguratorProps, ModalProps {
  configurator: ShowerDoorConfigurator;
}

interface MergedProps extends OwnProps {
  cdnUrl: string;
}

const imageUrl = (cdnUrl: string, image: string): string => {
  return `${cdnUrl}/configurator/showerdoor/${image}`;
};

const ShowerDoor = (props: MergedProps) => {
  const { attributes, configurator } = useConfigurator<ShowerDoorConfigurator>();
  const validate = rules(props);
  const imageKey = 'image';
  const image =
    configurator.values && imageKey in configurator.values ? configurator.values[imageKey] : '';
  const { isMaster, hasMasterConstraint } = masterAttribute({
    configurator: props.configurator,
    configAttributes: attributes
  });

  const component = match<Attribute, ReactElement>()
    .when(
      a => a.type === AttributeType.Select,
      a => <AttributeSelect {...{ ...a }} />
    )
    .when(
      a => a.type === AttributeType.AttributeFilter,
      a => <AttributeFilter {...{ ...a }} />
    )
    .when(
      a => a.type === AttributeType.NumericInput,
      a => <AttributeNumeric {...{ ...a, validate }} />
    )
    .when(
      a => a.type === AttributeType.Image,
      a => <AttributeImage {...{ ...a, isMaster, hasMasterConstraint }} />
    )
    .or(<></>)
    .toFunc();

  const minMaxHelper = (min: number, max: number, unit: string | undefined) => {
    return (
      <span className={showerStyle.minMaxHelper}>
        {min}-{max} {unit}
      </span>
    );
  };

  const control = (a: Attribute) => {
    const comp = component(a);
    const shouldDisplayTooltip = a.type !== AttributeType.Image && a.toolTip;

    return (
      <div key={a.name} className={cn(styles.cell, styles.one)}>
        <label className={showerStyle.inputHeader}>
          {shouldDisplayTooltip && <ToolTipDialog text={a.toolTip} />}
          {a.minValue && a.maxValue && minMaxHelper(a.minValue, a.maxValue, a.unit)}
        </label>
        {comp}
      </div>
    );
  };

  return (
    <div className={styles.base}>
      <div className={cn(styles.cell, styles.two)}>{attributes.map(control)}</div>
      <div className={cn(styles.cell, styles.two)}>
        <img className={showerStyle.showerImage} src={imageUrl(props.cdnUrl, image)} />
      </div>
    </div>
  );
};

export default connect<MergedProps, OwnProps>(({ appShell }) => ({
  cdnUrl: appShell.links.cdnUrl
}))(ShowerDoor);
